export * from './reportTemplate.service';
import { ReportTemplateService } from './reportTemplate.service';
export const APIS = [ReportTemplateService];
